import axios from "axios";
import { API_URL, DEHASH_API_URL } from "../utils/constant";
// import Cookies from "universal-cookie";
import { PASTEBIN_RECORD_FETCHED, PASTEBIN_RECORD_FETCHED_GRAPH, PASTEBIN_RECORD_FETCHED_TOTAL } from "./index";
import { toastr } from 'react-redux-toastr';



export const fetchPastebinResult = (props, dispatch, page, category, startDate, endDate, limit, search, keyword = 'all') => {
  if (props) {
    let url = `${API_URL}/pastebin/${props}/delta?page=${page}&limit=${limit}&category=${category}&from=${startDate}&till=${endDate}&search=${search}`;
    if (keyword && keyword !== 'all') {
      url += `&keyword=${keyword}`;
    }
    axios
      .get(url, {})
      .then((res) => {
        dispatch({
          type: PASTEBIN_RECORD_FETCHED,
          payload: res.data,
        });

      });
  }
};

export const pastebinUpdate = (props, dispatch, data, clear) => {
  if (props) {
    axios
      .patch(`${API_URL}/pastebin/${props}/update`, data)
      .then((res) => {
        if (res.data.status == 200) {
          toastr.success("Success", res.data.userMessage);
          fetchPastebinResult(props, dispatch, 1, 'all', '', '', 10, '', 'all')
          clear()
        } else {
          toastr.success("Error", res.data.userMessage);
        }
      });
  }
};

export const fetchPastebinResultAction = (props, dispatch, page, data, category, search, keyword = 'all') => {
  if (props) {
    let url = `${API_URL}/pastebin/${props}/action?page=${page}&category=${category}&search=${search}`;
    if (keyword && keyword !== 'all') {
      url += `&keyword=${keyword}`;
    }
    axios
      .post(url, data)
      .then((res) => {
        dispatch({
          type: PASTEBIN_RECORD_FETCHED,
          payload: res.data,
        });
        if (res.data.status == 200) {
          toastr.success("Success", res.data.userMessage);
        } else {
          toastr.success("Error", res.data.userMessage);
        }
      });
  }
};

export const pastebinDelete = (props, dispatch, id) => {
  if (props) {
    axios
      .delete(`${API_URL}/pastebin/${props}/${id}/delete`,)
      .then((res) => {
        if (res.data.status == 200) {
          toastr.success("Success", res.data.userMessage);
          fetchPastebinResult(props, dispatch, 1, 'all', '', '', 10, '', 'all')
        } else {
          toastr.success("Error", res.data.userMessage);
        }
      });
  }
};

export const fetchPastebinResultGraph = (props, dispatch) => {
  if (props) {
    axios
      .get(`${API_URL}/pastebin/${props}/graph`, {})
      .then((res) => {
        dispatch({
          type: PASTEBIN_RECORD_FETCHED_GRAPH,
          payload: res.data,
        });
      });
  }
};

export const fetchPastebinResultTotal = (props, dispatch, category = 'all', search = '', startDate = '', endDate = '', keyword = 'all') => {
  if (props) {
    let url = `${API_URL}/pastebin/${props}/totals?category=${category}&search=${search}&from=${startDate}&till=${endDate}`;
    if (keyword && keyword !== 'all') {
      url += `&keyword=${keyword}`;
    }
    axios
      .get(url, {})
      .then((res) => {
        dispatch({
          type: PASTEBIN_RECORD_FETCHED_TOTAL,
          payload: res.data,
        });

      });
  }
};
